module.exports = __webpack_public_path__ + "img/logo-text-bleu-blanc.7e4018c3.png";